import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const assetsReportsTemplateRoute: InvariantJiraRoute = {
	name: 'assets-reports',
	path: '/jira/assets/reports/:templateId',
	exact: true,
};
